import { render, staticRenderFns } from "./ClearData.vue?vue&type=template&id=80f4c14a&scoped=true&"
import script from "./ClearData.vue?vue&type=script&lang=js&"
export * from "./ClearData.vue?vue&type=script&lang=js&"
import style0 from "./ClearData.vue?vue&type=style&index=0&id=80f4c14a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f4c14a",
  null
  
)

export default component.exports